import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles } from 'decorators/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Dialog } from '@material-ui/core';

interface IProps {
  classes?: any;
  loader: boolean;
}

@WithStyles({
  loader: {
    height: '-webkit-fill-available',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#00000000'
  },
  animation: {
    animation: 'none',
    height: 60,
    width: 60,
    color: '#42b834'
  },
  paper: {
    boxShadow: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    overflow: 'hidden'
  }
})
class Loader extends Component<IProps, null> {
  render() {
    const { loader } = this.props;

    const { classes } = this.props;
    return (
      <Dialog open={loader} PaperProps={{ className: classes.paper }}>
        <CircularProgress classes={{ root: classes.animation }} />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    loader: state.forum.loader
  };
};

export default connect(mapStateToProps)(Loader);
